<template>
<ValidationProvider tag="div" :rules="rules" :label="label" v-slot="{ errors }">
    <div >
        <!-- {{agencyDet}} -->
        <label>{{label}}</label>
        <multiselect v-model="selValueModel" :track-by="'b2bcode'" :group-values="toShowAgencyGroup?'optLs':null" 
                    :group-label="toShowAgencyGroup?'grplabel':null" :group-select="false"
          :custom-label="agencyNameWithCode"
         :placeholder="$t('cAgent.select')" :options="options"
         :searchable="true" :multiple="isMultiSelect"
         :allow-empty="false" :loading="isLoading" v-on:input="getAgtDetByID" :showLabels="false" @open="onOpenAgentSelection" >


           <template slot="singleLabel" slot-scope="props">
               <span class="txt-over-ellips w-50" v-if="props.option['$groupLabel']">{{ props.option['$groupLabel'] }}</span>
                     <div class="d-flex cagent-selected">
                         <span class="txt-over-ellips w-50" v-if="props.option['agencyname']">{{ props.option['agencyname'] }}</span>
                     <span class="txt-over-ellips w-50" v-else-if="props.option['groupname']">{{ props.option['groupname'] }}</span>
                    <div class="right txt-over-ellips w-50" v-if="!props.option['groupname'] && props.option['b2bcode'] "   >({{ props.option['b2bcode'] }})</div>
                </div>

        </template>
            
            <template slot="option" slot-scope="props">
                <strong class="w-50 txt-over-ellips" v-if="props.option['$groupLabel']">{{ props.option['$groupLabel'] }}</strong>
                <div class="d-flex">
                    <strong class="w-50 txt-over-ellips" v-if="props.option['agencyname']">{{ props.option['agencyname'] }}</strong>
                <strong class="w-50 txt-over-ellips" v-else-if="props.option['groupname']">{{ props.option['groupname'] }}</strong>
                    <span class="text-right ml-auto w-50 txt-over-ellips" v-if="!props.option['groupname'] && props.option['b2bcode'] ">{{ props.option['b2bcode'] }}</span>
                </div>
            </template>
            <template #noResult>
                <strong >
                  {{resultEmpty}}
                </strong>
              </template>
              <template #noOptions>
                <strong >
                  {{optionEmpty}}
                </strong>
            </template>

        </multiselect>

        <div v-if=" errors && errors[0] && delay() && isDelay" class="invalid-feedback icon">
            <div v-show="!selValueModel">
                <span>{{ errors[0] }}</span>
            </div>
        </div>
        <div v-if="!isLoading && options.length==0" class="invalid-feedback icon">
            <div>
                <span>{{$t('cAgent.noAgent',{agtType:agentType==1?'Prepaid Agents'
                    :agentType==2?'Postpaid Agents':'Agents'})}}</span>
            </div>
        </div>
    </div>
</ValidationProvider>
</template>

<script>
import { differenceBy } from "../../util/util.js";

import router ,{navigate,goBack }from "../../router/index";

import {
    ValidationProvider
} from "vee-validate";
import Multiselect from "vue-multiselect";
import apiGetAllAgent from "../../services/apiGetAllAgent.js";

import apiGetAgentDetails from "../../services/apiGetAgentDetails.js";
import {
    mapGetters,
    mapActions
} from "vuex";
import {
    PATHNAME,
    COMPONENT_NAME,DEFAULT_DROPDOWN_STATUS,ORDER
} from "../../util/constants.js";
import BaseConfiguration from "../../config/base.js";
import {
    VALIDATE_SUCCESS_RES,
    getErrorMessage
} from "../../util/apiValidate.js";
import {
    handleJWT,
    getErrorAlertValue,OrderByList
} from "../../util/util";
import SERVICE_URL from "../../config/API_DATA";
import Logger from "../../services/logger";
import {
    LOG_TYPE,
    FILE_NAME,
    HTTP_CODES,
    API_VALUES
} from "../../config/API_DATA";
import apiGetB2bGrpList from "../../services/apiGetB2bGrpList";
export default {
    name: COMPONENT_NAME.C_AGENT,
    components: {
        ValidationProvider,
        Multiselect
    },
    model: {
        prop: "selValue"
    },
    props: {
        toShowAgencyGroup: {
            type: Boolean,
            default: false
        },
       isAll: {
            type: Boolean,
            default: false
        },
        isDisable: {
            type: Boolean,
            default: false
        },
        url: {
            type: String,
            default: null
        },
        selValue: {
            type: Array | Object,
            default: null
        },
       /*  isShowCode: {
            type: Boolean,
            default: false
        }, */
        isMultiple: {
            type: Boolean,
            default: false
        },
     /*    isSearchable: {
            type: Boolean,
            default: false
        },
        ctrlName: {
            type: String,
            default: ""
        },
        ctrlCode: {
            type: String,
            default: ""
        }, */

        rules: {
            type: [String, Object],
            default: ""
        },
        label: {
            type: String,
            default: ""
        },
        agentType:{
            type: Number|String,
        },
        isInactiveusers:{
            type: Boolean,
            default: true

        },
        resultEmpty: {
            type: String,
            // default: 'No matching items found'
            default: function () {
    return this.$t("cAgent.resEmpty") }
        },
        optionEmpty: {
            type: String,
            default: function () {
    return this.$t("cAgent.optEmpty") }
        },
        b2bCodeToSelectAgent: {
            type: String,
            default:null
        },
        unAssignedAgentList: null,
        isNeedAgntDetails:{
            type:Boolean,
            default:true
        }

    },
    data: () => ({

        options: [],
        selValueModel: null,
        agencyDet: null,
        isDelay : false,
        isMultiSelect:false,
        isLoading: false
    }),

    watch: {
        selValue(val) {
            if (val !== this.selValueModel) {
                this.selValueModel = val;
            }
        }
    },

    async created() {
       
        // if (this.url) {
             
        //       this.options = await this.getAllPendingAgent();
              
        //     if (BaseConfiguration.isDebug) console.log("getAllPendingAgent");
        // }
        // else{
            try {
            if (BaseConfiguration.isDebug) console.log(" created");

            
                this.isMultiSelect = this.isMultiple
            

            this.options = await this.getAgentOptions();
          
            this.selValueModel=this.selValue;
 if(this.b2bCodeToSelectAgent&&this.options){
          this.selValueModel=this.getSelValueByB2bCode(this.b2bCodeToSelectAgent,this.options);
                 if(this.selValueModel){
                 this.$emit('input', this.selValueModel);

                 }
            }
            if(this.isAll && this.agentType!='null' && this.options && this.options.length)
           {
               this.options.unshift({    b2bid: null,
                                        b2bcode: null,
                                        agencyname: DEFAULT_DROPDOWN_STATUS.ALL
               })
               this.selValueModel=this.options[0]
                                   
           }
           if(this.toShowAgencyGroup){
               let agentGrpLs = await this.getAgentGroupList();
               let optionLs = this.options
                   this.options=[]
                   let optLs=[]
                   if(agentGrpLs&&agentGrpLs.groupList){
               for (let i = 0; i < agentGrpLs.groupList.length; i++) {
                   agentGrpLs.groupList[i]["b2bcode"] = agentGrpLs.groupList[i].b2bGroupid;
                   optLs.push(agentGrpLs.groupList[i])
               }
                   }
               
                   this.options.push({grplabel:'Agent Group',optLs});
                   optLs=optionLs;
                   this.options.push({grplabel:'All Agent',optLs})
            }
                         if(this.selValueModel){
                 this.$emit('input', this.selValueModel);

                 }


        } catch (err) {
            let body = Logger.buildRequest(COMPONENT_NAME.C_AGENT, "error while Component created", err.toString(), "created", LOG_TYPE.ERROR);
            Logger.getResponse(body);
        }
        // }
        
    },

    computed: {
        ...mapGetters("sCAgent", {
            agentDetails: "GET_AGENT_DETAIL_RES"
        }),

    },

    methods: {

        
        ...mapActions("sCAgent", ["SET_AGENT_DETAIL_REQ"]),
        ...mapActions("sCAgent", ["SET_AGENT_DETAIL_RES"]),
        ...mapActions("sCAgent", ["CLEAR_C_AGENT_STORE"]),

    onOpenAgentSelection() {
          try {
            if(BaseConfiguration.isDebug) console.log("onOpenAgentSelection");
           this.$emit('openCAgent')
      
          } catch (err) {
                  let body = Logger.buildRequest(
                    COMPONENT_NAME.C_AGENT,
                    "error in onOpenAgentSelection",
                    err.toString(),
                    "onOpenAgentSelection",
                    LOG_TYPE.ERROR
                  );
                  Logger.getResponse(body);
                }
          
          }, 
      async getAgentGroupList() {
            let returnValue;
            try {
              if(BaseConfiguration.isDebug) console.log("getAgentGroupList");
               let getB2bGroupListReq = apiGetB2bGrpList.buildRequest(); //constant

        if (getB2bGroupListReq != null) {
          let getB2bGroupListRes = await apiGetB2bGrpList.getResponse(
            getB2bGroupListReq
          );
          if (VALIDATE_SUCCESS_RES(getB2bGroupListRes)) {
                        this.alertValue=null;

          
            returnValue = getB2bGroupListRes.data.data;
          } else {
            let error = getErrorMessage(getB2bGroupListRes);

            let isJwt = handleJWT(error);
            if (!isJwt) {
              this.alertValue=getErrorAlertValue(error);
            }
          }
        } else {
          throw "invalid request";
        }
        
            } catch (err) {
                    let body = Logger.buildRequest(
                      COMPONENT_NAME.C_AGENT,
                      "error in getAgentGroupList",
                      err.toString(),
                      "getAgentGroupList",
                      LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                  }
              return returnValue;
       }, 

        getSelValueByB2bCode(pB2bCode,pOptions) {
                          let retValue;

            try {
              if(BaseConfiguration.isDebug) console.log("getSelValueByB2bCode");
              for(let i=0;i<pOptions.length;i++){
                  if(pOptions[i].b2bcode==pB2bCode){
                      retValue=pOptions[i];
                      break;
                  }
              }
            } catch (err) {
                    let body = Logger.buildRequest(
                      COMPONENT_NAME.C_AGENT,
                      "error in getSelValueByB2bCode",
                      err.toString(),
                      "getSelValueByB2bCode",
                      LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                  }
              return retValue;
            }, 

    async delay() { //to avoid 1 sec error msg in UI.
        //let retValue = false;
        try {
          if(BaseConfiguration.isDebug) console.log("dealy");   
            let that = this;
           await setTimeout(function(){
            that.isDelay = true;
           },500) 
        } catch (err) {
                let body = Logger.buildRequest(
                  COMPONENT_NAME.C_AGENT,
                  "error in dealy",
                  err.toString(),
                  "dealy",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
          //return retValue;
        }, 
      //for custom search
      agencyNameWithCode(option) {
          if(option.agencyname){
      return `${option.agencyname}  (${option.b2bcode})`;
          }else if(option.groupname){
             return `${option.groupname}`; 
          }
    },
   

        ///method to get options
        async getAgentOptions() {
            if (BaseConfiguration.isDebug) console.log("getAgentOptions");
            let retValue = null;
            try {
               

                    let allAgentRes = await this.getAllAgentsRes();
                    if(this.unAssignedAgentList!=null){
                    if(allAgentRes && this.unAssignedAgentList.length>0){
                        let agentList=differenceBy(allAgentRes, this.unAssignedAgentList, 'b2bid');
                        retValue = agentList;
                    }
                    }else if (allAgentRes) {
                        retValue = allAgentRes;

                    } else {
                        retValue = [];
                    }
                
                   retValue=OrderByList(retValue,this.getPropToSortAgents,ORDER.ASC);

            } catch (err) {
                let body = Logger.buildRequest(COMPONENT_NAME.C_AGENT, "error in getinng Options", err.toString(), "getOptions", LOG_TYPE.ERROR);
                Logger.getResponse(body);
            }
            return retValue;
        },

        getPropToSortAgents(pAgent) {
         

            try {
              if(BaseConfiguration.isDebug) console.log("getPropToSortAgents");
              if( pAgent.agencyname){
            return  pAgent.agencyname.toLowerCase();

              }
            } catch (err) {
                    let body = Logger.buildRequest(
                      COMPONENT_NAME.C_AGENT,
                      "error in getPropToSortAgents",
                      err.toString(),
                      "getPropToSortAgents",
                      LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                  }
              
            }, 

            toCheckValidSelection(pselectedOption) {
                let retValue;
                try {
                  if(BaseConfiguration.isDebug) console.log("toCheckValidSelection");
                  if(pselectedOption.length>1){
                    //   if(Object.keys(pselectedOption[pselectedOption.length-1]).length!=Object.keys(pselectedOption[pselectedOption.length-2]).length){
                      if((pselectedOption[pselectedOption.length-1].hasOwnProperty('b2bGroupid') && !pselectedOption[pselectedOption.length-2].hasOwnProperty('b2bGroupid')) ||
                         (!pselectedOption[pselectedOption.length-1].hasOwnProperty('b2bGroupid') && pselectedOption[pselectedOption.length-2].hasOwnProperty('b2bGroupid'))){
                          let selOption=[];
                          selOption.push(pselectedOption[pselectedOption.length-1])
                          retValue=selOption
                      }
                       else{
                           retValue=pselectedOption
                       }   
                  }
                  else{
                       retValue=pselectedOption  
                     }
                     if(this.isMultiSelect==false){
                         retValue=[retValue]
                     }
                   if(Object.keys(retValue[retValue.length-1]).length==4) {
                       this.isMultiSelect=false;
                   } else{
                       if(this.isMultiple){
                       this.isMultiSelect=true;

                       }
                   }  
            
                } catch (err) {
                        let body = Logger.buildRequest(
                          COMPONENT_NAME.C_AGENT,
                          "error in toCheckValidSelection",
                          err.toString(),
                          "toCheckValidSelection",
                          LOG_TYPE.ERROR
                        );
                        Logger.getResponse(body);
                      }
                  return retValue;
            }, 

        /// api call to get the agent details by using id
        async getAgtDetByID(selectedOption) {
            try {

                if (BaseConfiguration.isDebug) console.log("getAgtDetByID");
                if(this.toShowAgencyGroup){
                   selectedOption=this.toCheckValidSelection(selectedOption)
                }
                this.selValueModel = this.selValue;
                  if(this.isAll)
                  {
              this.$emit('input', selectedOption);
                  } else if(this.isNeedAgntDetails==false)
                  {
              this.$emit('input', selectedOption);
                  } 
                  else
                  {
                let agtDetRes = await this.getAgentDetails(selectedOption); ///method to get agent details from api
                this.$emit('input', agtDetRes);
                  }

            } catch (err) {
                let body = Logger.buildRequest(COMPONENT_NAME.C_AGENT, "error in getinng Agent Details", err.toString(), "getAgtDetByID", LOG_TYPE.ERROR);
                Logger.getResponse(body);
            }
        },

        ///method to get agent details from api
        async getAgentDetails(selectedOption) {
            let retValue;
            try {
                if (BaseConfiguration.isDebug) console.log(" getAgentDetails");
                let getAgtDetReq = apiGetAgentDetails.buildRequest(selectedOption.b2bid);
                if (getAgtDetReq) {
                    this.SET_AGENT_DETAIL_REQ(getAgtDetReq); //save req in store
                    let getAgtDetRes = await apiGetAgentDetails.getResponse(getAgtDetReq);

                    if (VALIDATE_SUCCESS_RES(getAgtDetRes)) {

                        this.SET_AGENT_DETAIL_RES(getAgtDetRes); //save res in store
                        retValue = getAgtDetRes.data.data;
                        if (this.agentDetails != null) {
                            this.agencyDet = JSON.parse(
                                JSON.stringify(this.agentDetails.data.data)
                            ); //save the details of selected id

                        }

                    }
                    // else if(getAgtDetRes.data.data){
                    //     this.alertValue = getAgtDetRes.data.error[0];

                    // }
                    else {
                        let error = getErrorMessage(getAgtDetRes);

                        let isJwt = handleJWT(error);
                        if (!isJwt) {
                            this.alertValue = getErrorAlertValue(error)
                        }
                    }
                } 
            } catch (err) {
                let body = Logger.buildRequest(
                    COMPONENT_NAME.C_AGENT,
                    "error in getting response from GetAgentDetails API",
                    err.toString(),
                    "getAgentDetails",
                    LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
            }
            return retValue;
        },

        ///to check a invalid option
        isInValidOptions() {
            try {
                if (BaseConfiguration.isDebug) console.log(" isInValidOptions");

                let retValue = false;
                if (this.options && this.options.length > 0)
                    //check options length
                    retValue = false;
                else retValue = true;
                return retValue;
            } catch (err) {
                let body = Logger.buildRequest(
                    COMPONENT_NAME.C_AGENT,
                    "error while checking invalid options",
                    err.toString(),
                    "isInValidOptions",
                    LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
            }
        },

       

        //api call to get all agent list
        async getAllAgentsRes() {

            if (BaseConfiguration.isDebug) console.log(" getAllAgentsRes");

            let retValue;
            try {
                let inactiveUsers=this.isInactiveusers;
                let agentType=null;
                if(this.agentType=="null")
                {
                    agentType=null;
                }
                else{
                    agentType= this.agentType;
                }

                let getAllAgtReq = apiGetAllAgent.buildRequest(true, inactiveUsers,agentType);
                if (getAllAgtReq) {
                    this.isLoading = true;
                    //this.SET_ALL_AGENT_REQ(getAllAgtReq); //save req in store
                    let getAllAgtRes = await apiGetAllAgent.getResponse(getAllAgtReq);

                    if (VALIDATE_SUCCESS_RES(getAllAgtRes) &&
                        getAllAgtRes.data.data.length > 0
                    ) {
                        this.isLoading = false;
                        retValue = getAllAgtRes.data.data;
                        // this.SET_ALL_AGENT_RES(retValue); //save res in store
                    } else if (getAllAgtRes.data.data) {
                        this.isLoading = false;
                        this.noAgents = true;
                    } else {
                        this.isLoading = false;
                        let error = getErrorMessage(getAllAgtRes);

                        let isJwt = handleJWT(error);
                        if (!isJwt) {
                            this.alertValue = getErrorAlertValue(error)
                        }
                    }

                } else {
                    throw "invalid request";
                }
            } catch (err) {
                let body = Logger.buildRequest(
                    COMPONENT_NAME.C_AGENT,
                    "error in getting response from GetAllAgent API",
                    err.toString(),
                    "getAllAgentsRes",
                    LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
            }
            return retValue;
        },

    }
};
</script>

